// extracted by mini-css-extract-plugin
export var locationCard = "_h6-0";